<template>
    <div class="c-article__reposted" v-if="!!communities.length">
        <h5>Reposted to:</h5>
        <div id="reposted" class="c-communities__wrapper c-communities__wrapper--article">
            <div class="c-communities__tile" v-for="community in communities">
                <a :href="'/' + community.url">
                    <img class="c-communities__img" :src="$simpleStore.transformImageWithCloudfront(210, 210, 'img/communities/' + community.community_id + '/' + community.image, $root)">
                </a>
                <div class="c-communities__name">
                    <a :href="'/' + community.url">{{community.name}}</a>
                </div>
            </div>
        </div>
        <div class="c-article__more-btn" v-if="communities.length > 5">
            <a href="#0" class="c-btn3">More</a>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            communities: []
        }
    },
    created() {
        this.fetchData();
    },
    methods: {
        fetchData() {
            this.$http.get('/api/v1/posts/reposted/' + this.$root.dyadey_id, {}).then(response => {
                this.communities = response.data;
            }, response => {
                console.log('Errored:');
                console.log(response);
            });
        }
    }
}
</script>
